import React, { useEffect } from 'react'
import { injectIntl } from 'react-intl'
import Typography from '@material-ui/core/Typography'
import { connect } from 'react-redux'
import qs from 'qs'
import FilterBar from 'components/common/Filterbar/SisenseFilterBar'
import DashboardView from 'components/common/Dashboard/SisenseDashboard'
import 'styles/app/apps/salesDashboard/sales-dashboard.scss'
import ifWindowWidthLessThan from 'helpers/ifWindowWidthLessThan'
import {
  sisenseFetchListByApplication,
  sisenseClearData,
  setActiveSisenseData,
} from 'reducers/sisense/reducer'
import cn from 'classnames'
import { logMonitorActivity } from 'reducers/environmentMonitor/reducer'
import withPromise from 'helpers/withPromise'
import { EVENT_TYPES } from '../MonitorsAndAlerts/logTypes'
import { LAPTOP_BREAKPOINT } from '../../../../helpers/responsive'

function SisenseDashboards({
  currentApp: { name: appName, id: licenseeApplicationId, applicationId },
  sisenseList,
  sisenseFetchListByApplication,
  match: {
    params: { slug },
  },
  location: { search, pathname },
  sisenseClearData,
  setActiveSisenseData,
  history: { push },
  embedLink,
  refreshTriggerInterval,
  id: idProps,
  activeSite,
  logMonitorActivity,
  featureFlags,
}) {
  const sisenseListArr = sisenseList.toArray()
  const currentSlug = slug || (sisenseListArr[0] && sisenseListArr[0].slug)

  if (
    sisenseListArr &&
    sisenseListArr.length === 1 &&
    slug !== sisenseListArr[0].slug
  ) {
    if (!slug) {
      push(`${pathname}/${sisenseListArr[0].slug}`)
    } else {
      push(sisenseListArr[0].slug)
    }
  }

  const link =
    (embedLink === '' && sisenseListArr.length > 0) ||
    sisenseListArr.length === 1
      ? sisenseListArr[0].embedLink
      : embedLink
  const id =
    idProps === 0 && sisenseListArr.length > 0 ? sisenseListArr[0].id : idProps
  const refresh =
    refreshTriggerInterval === null && sisenseListArr.length > 0
      ? sisenseListArr[0].refreshTriggerInterval
      : refreshTriggerInterval
  const dashboard =
    sisenseListArr.find(({ id: dashboardId }) => dashboardId === id) ||
    sisenseListArr[0]

  useEffect(() => {
    if (id > 0 && dashboard) {
      logMonitorActivity({
        licensee_application: licenseeApplicationId,
        application: applicationId,
        site: activeSite,
        event_name: EVENT_TYPES.TAB_CLICK,
        sisense_dashboard: id,
        tab_name: dashboard.name,
        application_url: pathname,
        referrer: null,
      })
    }
  }, [id])

  useEffect(() => {
    const list = sisenseList.toArray()
    const currentSlug = slug || (list[0] && list[0].slug)
    const params = qs.parse(search, { ignoreQueryPrefix: true })
    let parsedParams = null
    const { name: tabName } =
      list.find(({ slug: slugData }) => slugData === slug) || list[0] || {}
    const logData = {
      licensee_application: licenseeApplicationId,
      application: applicationId,
      site: activeSite,
      event_name: EVENT_TYPES.APP_VIEW,
      tab_name: tabName || '',
      application_url: pathname,
      referrer: localStorage.getItem('referrer') || null,
    }

    logMonitorActivity(logData)

    if (params) {
      const jsonParams = params.json_params

      try {
        const data_ts = Math.round(Date.now() / 1000)
        parsedParams = JSON.parse(jsonParams)
        parsedParams = { ...parsedParams, data_ts }
      } catch (e) {
        parsedParams = null
      }
    }

    withPromise(sisenseFetchListByApplication, {
      id: licenseeApplicationId,
      jsonParams: parsedParams,
      slug: currentSlug,
    }).then(errors => {
      if (errors) {
        Promise.resolve(errors)
      }
    })

    return () => {
      sisenseClearData()
    }
  }, [])

  const setSisenseData = ({ embedLink, refreshTriggerInterval, id }) => {
    const { slug: slugData } = sisenseList.find(
      ({ id: idData }) => idData === id,
    )

    if (!slug) {
      push(`${pathname}/${slugData}`)
    } else {
      push(slugData)
    }

    setActiveSisenseData({ embedLink, refreshTriggerInterval, id })
  }

  return (
    <div className="module module-sales-dashboard">
      <div
        className={cn('module-head', {
          'old-header':
            !featureFlags.APP_HEADER_V2 ||
            !ifWindowWidthLessThan(LAPTOP_BREAKPOINT),
        })}>
        <Typography className="module-title" variant="h5">
          {appName}
        </Typography>
        {sisenseListArr.length > 1 && (
          <FilterBar
            embedLink={link}
            id={id}
            sisenseList={sisenseListArr}
            slug={currentSlug}
            setSisenseData={setSisenseData}
            refreshTriggerInterval={refresh}
          />
        )}
      </div>
      <div className="module-content">
        <DashboardView
          embedLink={link}
          refreshTriggerInterval={refresh}
          key={refresh}
        />
      </div>
    </div>
  )
}

export default connect(
  state => ({
    embedLink: state.getIn(['sisense', 'embedLink']),
    sisenseList: state.getIn(['sisense', 'sisenseList']),
    refreshTriggerInterval: state.getIn(['sisense', 'refreshTriggerInterval']),
    id: state.getIn(['sisense', 'id']),
    activeSite: state.getIn(['profile', 'siteId']),
    featureFlags: state.getIn(['profile', 'profile', 'featureFlags']),
  }),
  {
    sisenseFetchListByApplication,
    sisenseClearData,
    setActiveSisenseData,
    logMonitorActivity,
  },
)(injectIntl(SisenseDashboards))
